module.exports = __webpack_public_path__ + "img/buenos_aires_puerto_madero.bacbd46f.jpg";